// libs/core/src/lib/settings/settings.controller.ts
import { BehaviorSubject } from "rxjs";
import { JsonParser, storage } from "@one-inch-community/core/storage";
var SettingsController = class {
  constructor(name, initValue = null) {
    this.name = name;
    this.initValue = initValue;
    this.valueState$ = new BehaviorSubject(getPersistValue(this.name) ?? this.initValue);
    this.value$ = this.valueState$;
    this.originalValue = null;
  }
  get value() {
    return this.valueState$.value;
  }
  setValue(value) {
    this.valueState$.next(value);
    updatePersist(this.name, value);
  }
  resetValue() {
    this.valueState$.next(this.originalValue);
    updatePersist(this.name, this.originalValue);
  }
  cleanValue() {
    this.valueState$.next(null);
    updatePersist(this.name, null);
  }
  startChangingValue() {
    if (this.originalValue !== null) {
      throw new Error("value changing in progress");
    }
    this.originalValue = this.value;
  }
  endChangingValue() {
    this.originalValue = null;
  }
};
var persistStorageKey = "one-inch-settings";
function updatePersist(name, value) {
  const data = storage.get(persistStorageKey, JsonParser) ?? {};
  storage.set(persistStorageKey, { ...data, [name]: value });
}
function getPersistValue(name) {
  const data = storage.get(persistStorageKey, JsonParser);
  if (data === null) return null;
  return Reflect.get(data, name);
}
export {
  SettingsController
};
//# sourceMappingURL=index.esm.js.map
